import { render, staticRenderFns } from "./mrztqz.vue?vue&type=template&id=2270f4fb&scoped=true"
import script from "./mrztqz.vue?vue&type=script&lang=js"
export * from "./mrztqz.vue?vue&type=script&lang=js"
import style0 from "./mrztqz.vue?vue&type=style&index=0&id=2270f4fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2270f4fb",
  null
  
)

export default component.exports